import { render, staticRenderFns } from "./AddNewCampaign.vue?vue&type=template&id=8a5b67f4&scoped=true&"
import script from "./AddNewCampaign.vue?vue&type=script&lang=js&"
export * from "./AddNewCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddNewCampaign.vue?vue&type=style&index=0&id=8a5b67f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5b67f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VBtn,VCol,VContainer,VDatePicker,VFlex,VLayout,VProgressCircular,VRow,VSimpleTable,VTimePicker})
